export default "__VITE_ASSET__O1VqTaiZ__";